/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { parse, stringify } from 'query-string'

export function convertOnboardingServiceTypeToRedirectTo(redirectURL: string): string {
  const [pathname, search] = redirectURL.split('?')

  const query = search ? parse(search) : {}
  const { onboarding_service_type } = query

  if (typeof onboarding_service_type === 'string') {
    delete query.onboarding_service_type
    query.redirectTo = `/home?onboarding_service_type=${onboarding_service_type}`
  }

  const queryString = stringify(query)

  if (pathname && queryString) {
    return `${pathname}?${queryString}`
  }

  return pathname || ''
}

export function convertFromURIToOnboardingServiceType(redirectURL: string): string {
  const [pathname, search] = redirectURL.split('?')

  const query = search ? parse(search) : {}
  const { fromURI } = query

  if (typeof fromURI === 'string') {
    const decodedFromURI = decodeURIComponent(fromURI)

    if (decodedFromURI.startsWith('/home?onboarding_service_type=')) {
      const onboardingServiceTypeMatch = decodedFromURI.match(/onboarding_service_type=([^&]+)/)

      if (onboardingServiceTypeMatch) {
        query.onboarding_service_type = onboardingServiceTypeMatch[1] ?? null
        delete query.fromURI
      }
    }
  }

  const queryString = stringify(query)

  if (pathname && queryString) {
    return `${pathname}?${queryString}`
  }

  return pathname || ''
}
